import { Behavior } from '@cewe-designsystem/abstract';

@Behavior('event-mirror')
export class EventMirror {
  element: HTMLElement;

  name: string;
  type: string;
  scopeSelector: string;
  scopeElement: Element;
  fromSelector: string;
  fromElement: HTMLElement;

  constructor(element) {
    this.element = element;
  }

  // called when the `element` is added to the DOM
  connectedCallback() {
    // name of the event to mirror
    this.name = this.element.getAttribute('event-mirror-name');
    // name of the event type to mirror defaults to MouseEvent
    this.type = this.element.getAttribute('event-mirror-type') || 'MouseEvent';
    // the scope as a selector based on the element with this behavior
    this.scopeSelector = this.element.getAttribute('event-mirror-scope');
    // get the scope element by selector
    this.scopeElement = this.getScopeElement(this.scopeSelector);
    // the selector of the element in the scope where we want to mirror an event
    this.fromSelector = this.element.getAttribute('event-mirror-from');
    // the element of the mirrored event
    this.fromElement = this.scopeElement.querySelector(this.fromSelector);

    // set cursor to pointer of mirrored element and default to pointer if nothing is set
    this.element.style.cursor = this.fromElement.style.cursor || 'pointer';
    // add event listener to the element with behavior that should act with the mirrored event
    this.element.addEventListener(this.name, (event) => {
      this.fromElement.dispatchEvent(new window[this.type](this.name));

      // prevent default events
      event.preventDefault();
    });
  }

  // called when the `element` is removed from the DOM
  disconnectedCallback() {}

  /**
   * getScopeElement
   * @param scopeSelector
   */
  getScopeElement(scopeSelector: string): Element {
    if (scopeSelector) {
      if (scopeSelector == 'parent') {
        return this.element.parentElement;
      }

      return this.element.closest(scopeSelector);
    } else {
      return this.element.parentElement;
    }
  }
}
